//Regex and validations
export const BASE_URLS = {
  HUISARREST_BASE_URL: 'https://www.huisarrest.com',
};

export const INTRO_REGEX = /\[|\]/gi;
